
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/matkat/[slug]",
      function () {
        return require("private-next-pages/matkat/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/matkat/[slug]"])
      });
    }
  